declare var gtag: any

export const isLocal = window.location.href.includes('localhost:')

const namespace = 'ga-event'

let _category = 'default'
export function init(category: string) {
  _category = category
  action('init', 'init')
}
export function action(
  eventType: 'init' | 'click' | 'event',
  label: string,
  isInteraction: boolean = true,
) {
  let cat = isLocal ? 'local-' + _category : _category
  //let lab = cat + '/' + label
  console.log(namespace, 'screen-view', label)
  _gtag(eventType, label, isInteraction)
  // _gtag('screen_view', {
  //   screen_name: lab,
  // })
  // https://developers.google.com/gtagjs/reference/event#screen_view
  // gtag('event', 'screen_view', {
  //   screen_name: 'About'
  // });
}

function _gtag(
  eventType: string,
  label: string,
  isInteraction: boolean = true,
) {
  if (typeof gtag !== 'undefined') {
    // gtag('event', eventType, data)
    // console.log(namespace, eventType)

    let cat = isLocal ? 'local-' + _category : _category // + '-' + category2
    if (!isInteraction) {
      gtag('event', eventType, {
        event_category: cat,
        event_label: label,
        non_interaction: true,
      })
    } else {
      gtag('event', eventType, {
        event_category: cat,
        event_label: label,
      })
    }

    let location = '/'
    if (isLocal) {
      location += 'local/'
    }
    location += 'app/'
    location += _category + '/'
    location += eventType + '/'
    location += label

    gtag('event', 'page_view', {
      page_location: location,
    })
  } else {
    console.log(namespace, 'analytics not init', eventType)
  }
}
